export const WS_EVENTS = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  GAME_OPEN: 'game-open',
  GAME_CLOSE: 'game-close',
  DEPOSIT_SUCCESS: 'success_dep',
  DEPOSIT_FAILED: 'deposit-failed',
  CASHOUT_SUCCESS: 'success_cashout',
  CASHOUT_FAILE: 'cashout-failed',
  PAGE_OPEN: 'page-open',
  MOUSE_OUT: 'mouseout',
  MOUSE_IN: 'mousein',
} as const;

export type WS_EVENT = (typeof WS_EVENTS)[keyof typeof WS_EVENTS];
